<template>
  <el-dialog
    title="样式编辑"
    :visible.sync="dialogShow"
    width="1000px">
    <div class="options_box">
     <el-button type="primary" @click="runCss()" size="small">运行</el-button>
    </div>
    <!-- <codemirror class="codemirror" v-model="code" :options="cmOption" /> -->
    <codemirror-example ref="codemirrorExample" v-model="code" :cmMode="'css'"></codemirror-example>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogShow = false">取 消</el-button>
      <el-button type="primary" @click="saveStyle">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import dedent from 'dedent'
  import CodemirrorExample from '../codemirror-example/index.vue'


  // import { codemirror } from 'vue-codemirror'
  // import 'codemirror/lib/codemirror.css'
  // // language
  // import 'codemirror/mode/css/css.js'

  // // theme css
  // import 'codemirror/theme/paraiso-light.css'

  // // require active-line.js
  // import'codemirror/addon/selection/active-line.js'
  
  export default {
    name: 'codemirror-example-css',
    components: {
      // codemirror,
      CodemirrorExample
    },
    data() {
      return {
        uuid: null,
        dialogShow: false,
        cmOption: {
          tabSize: 1,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          mode: 'text/css',
          theme: 'paraiso-light'
        },
        code: dedent``
      }
    },
  created() {
  },
    methods: {
      show(option) {
        if (option.style) {
          this.code = option.style;
        } else {
          let styleInfo = localStorage.getItem('styleInfo');
          this.code = styleInfo ?  dedent`${styleInfo}` : '';
        }
        this.$nextTick(() => {
          this.$refs.codemirrorExample.setValue(this.code);
        })
        this.dialogShow = true;
      },
      runCss(styleInfo) {
        this.code = styleInfo || this.code;
        if (this.uuid) {
          let styleEl = document.querySelector(`#style${this.uuid}`);
          document.head.removeChild(styleEl);
        }
        this.uuid = require('uuid').v1();
        let styleEl = document.createElement('style')
        styleEl.id = 'style'+this.uuid;
        styleEl.type = 'text/css';
        styleEl.innerHTML = this.code;
        document.head.appendChild(styleEl);
      },
      saveStyle() {
        localStorage.setItem('styleInfo', this.code);
        this.runCss();
        this.hide();
      },
      hide() {
        this.dialogShow = false;
      }
    }
  }
</script>
<style scoped>
.options_box{
  margin-bottom: 10px;
}
/deep/ .el-dialog__body{
  padding: 10px;
}
</style>